export function LogoMark() {
  return (
    <svg
      fill="none"
      height="100%"
      viewBox="0 0 29 24"
      width="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Porto</title>
      <g className="dark:hidden">
        <path
          clipRule="evenodd"
          d="M1.09783 14.4915C0.491516 14.4915 0 14.983 0 15.5893V18.5571C0.314078 18.3468 0.691822 18.2241 1.09822 18.2241H27.4462C27.8522 18.2241 28.2297 18.3466 28.5436 18.5566V15.5893C28.5436 14.983 28.0521 14.4915 27.4458 14.4915H1.09783ZM28.5436 20.1708C28.528 19.578 28.0426 19.1024 27.4462 19.1024H1.09822C0.491903 19.1024 0.000387245 19.5939 0.000387245 20.2002V22.3959C0.000387245 22.9843 0.463423 23.4647 1.04504 23.4924C1.06253 23.4933 1.08013 23.4937 1.09783 23.4937H27.4458C28.0521 23.4937 28.5436 23.0022 28.5436 22.3958V20.1708Z"
          fill="black"
          fillOpacity="0.4"
          fillRule="evenodd"
        />
        <path
          d="M0 20.2001C0 19.5938 0.491516 19.1023 1.09783 19.1023H27.4458C28.0521 19.1023 28.5436 19.5938 28.5436 20.2001V22.3958C28.5436 23.0021 28.0521 23.4936 27.4458 23.4936H1.09783C0.491517 23.4936 0 23.0021 0 22.3958V20.2001Z"
          fill="black"
          fillOpacity="0.5"
        />
        <path
          clipRule="evenodd"
          d="M1.9761 0C0.884729 0 0 0.884729 0 1.9761V9.33523C0.314078 9.12489 0.691822 9.00221 1.09822 9.00221H27.4462C27.8522 9.00221 28.2297 9.12469 28.5436 9.33472V1.9761C28.5436 0.884729 27.6589 0 26.5675 0H1.9761ZM28.5436 10.949C28.5281 10.3562 28.0427 9.88048 27.4462 9.88048H1.09822C0.491903 9.88048 0.000387245 10.372 0.000387245 10.9783V13.9459C0.314389 13.7357 0.691989 13.6132 1.09822 13.6132H27.4462C27.8522 13.6132 28.2297 13.7356 28.5436 13.9457V10.949ZM23.6042 1.97606C22.0884 1.97606 20.8596 3.20485 20.8596 4.72064C20.8596 6.23643 22.0884 7.46522 23.6042 7.46522H23.8238C25.3395 7.46522 26.5683 6.23643 26.5683 4.72064C26.5683 3.20485 25.3395 1.97606 23.8238 1.97606H23.6042Z"
          fill="black"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <path
          d="M0 20.2001C0 19.5938 0.491516 19.1023 1.09783 19.1023H27.4458C28.0521 19.1023 28.5436 19.5938 28.5436 20.2001V22.3958C28.5436 23.0021 28.0521 23.4936 27.4458 23.4936H1.09783C0.491517 23.4936 0 23.0021 0 22.3958V20.2001Z"
          fill="black"
          fillOpacity="0.5"
        />
        <path
          clipRule="evenodd"
          d="M1.09783 14.4915C0.491516 14.4915 0 14.983 0 15.5893V18.5571C0.314078 18.3468 0.691822 18.2241 1.09822 18.2241H27.4462C27.8522 18.2241 28.2297 18.3466 28.5436 18.5566V15.5893C28.5436 14.983 28.0521 14.4915 27.4458 14.4915H1.09783ZM28.5436 20.1708C28.528 19.578 28.0426 19.1024 27.4462 19.1024H1.09822C0.491903 19.1024 0.000387245 19.5939 0.000387245 20.2002V22.3959C0.000387245 22.9843 0.463423 23.4647 1.04504 23.4924C1.06253 23.4933 1.08013 23.4937 1.09783 23.4937H27.4458C28.0521 23.4937 28.5436 23.0022 28.5436 22.3958V20.1708Z"
          fill="black"
          fillOpacity="0.4"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M1.09783 9.8999C0.491516 9.8999 0 10.3914 0 10.9977V13.9656C0.314078 13.7552 0.691822 13.6325 1.09822 13.6325H27.4462C27.8522 13.6325 28.2297 13.755 28.5436 13.965V10.9977C28.5436 10.3914 28.0521 9.8999 27.4458 9.8999H1.09783Z"
          fill="black"
          fillOpacity="0.4"
          fillRule="evenodd"
          opacity="0.5"
        />
      </g>
      <g className="not-dark:hidden">
        <path
          clipRule="evenodd"
          d="M1.09783 14.4915C0.491516 14.4915 0 14.983 0 15.5893V18.5571C0.314078 18.3468 0.691822 18.2241 1.09822 18.2241H27.4462C27.8522 18.2241 28.2297 18.3466 28.5436 18.5566V15.5893C28.5436 14.983 28.0521 14.4915 27.4458 14.4915H1.09783ZM28.5436 20.1708C28.528 19.578 28.0426 19.1024 27.4462 19.1024H1.09822C0.491903 19.1024 0.000387245 19.5939 0.000387245 20.2002V22.3959C0.000387245 22.9843 0.463423 23.4647 1.04504 23.4924C1.06253 23.4933 1.08013 23.4937 1.09783 23.4937H27.4458C28.0521 23.4937 28.5436 23.0022 28.5436 22.3958V20.1708Z"
          fill="white"
          fillOpacity="0.4"
          fillRule="evenodd"
        />
        <path
          d="M0 20.2001C0 19.5938 0.491516 19.1023 1.09783 19.1023H27.4458C28.0521 19.1023 28.5436 19.5938 28.5436 20.2001V22.3958C28.5436 23.0021 28.0521 23.4936 27.4458 23.4936H1.09783C0.491517 23.4936 0 23.0021 0 22.3958V20.2001Z"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          clipRule="evenodd"
          d="M1.9761 0C0.884729 0 0 0.884729 0 1.9761V9.33523C0.314078 9.12489 0.691822 9.00221 1.09822 9.00221H27.4462C27.8522 9.00221 28.2297 9.12469 28.5436 9.33472V1.9761C28.5436 0.884729 27.6589 0 26.5675 0H1.9761ZM28.5436 10.949C28.5281 10.3562 28.0427 9.88048 27.4462 9.88048H1.09822C0.491903 9.88048 0.000387245 10.372 0.000387245 10.9783V13.9459C0.314389 13.7357 0.691989 13.6132 1.09822 13.6132H27.4462C27.8522 13.6132 28.2297 13.7356 28.5436 13.9457V10.949ZM23.6042 1.97606C22.0884 1.97606 20.8596 3.20485 20.8596 4.72064C20.8596 6.23643 22.0884 7.46522 23.6042 7.46522H23.8238C25.3395 7.46522 26.5683 6.23643 26.5683 4.72064C26.5683 3.20485 25.3395 1.97606 23.8238 1.97606H23.6042Z"
          fill="white"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <path
          d="M0 20.2001C0 19.5938 0.491516 19.1023 1.09783 19.1023H27.4458C28.0521 19.1023 28.5436 19.5938 28.5436 20.2001V22.3958C28.5436 23.0021 28.0521 23.4936 27.4458 23.4936H1.09783C0.491517 23.4936 0 23.0021 0 22.3958V20.2001Z"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          clipRule="evenodd"
          d="M1.09783 14.4915C0.491516 14.4915 0 14.983 0 15.5893V18.5571C0.314078 18.3468 0.691822 18.2241 1.09822 18.2241H27.4462C27.8522 18.2241 28.2297 18.3466 28.5436 18.5566V15.5893C28.5436 14.983 28.0521 14.4915 27.4458 14.4915H1.09783ZM28.5436 20.1708C28.528 19.578 28.0426 19.1024 27.4462 19.1024H1.09822C0.491903 19.1024 0.000387245 19.5939 0.000387245 20.2002V22.3959C0.000387245 22.9843 0.463423 23.4647 1.04504 23.4924C1.06253 23.4933 1.08013 23.4937 1.09783 23.4937H27.4458C28.0521 23.4937 28.5436 23.0022 28.5436 22.3958V20.1708Z"
          fill="white"
          fillOpacity="0.4"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M1.09783 9.8999C0.491516 9.8999 0 10.3914 0 10.9977V13.9656C0.314078 13.7552 0.691822 13.6325 1.09822 13.6325H27.4462C27.8522 13.6325 28.2297 13.755 28.5436 13.965V10.9977C28.5436 10.3914 28.0521 9.8999 27.4458 9.8999H1.09783Z"
          fill="white"
          fillOpacity="0.4"
          fillRule="evenodd"
          opacity="0.5"
        />
      </g>
    </svg>
  )
}
